// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isExists as fn } from "../isExists.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isExists = convertToFP(fn, 3);

// Fallback for modularized imports:
export default isExists;
